import {
    CRUD_CREATE_SUCCESS,
    CRUD_CREATE_FAILURE,
    CRUD_GET_ONE_SUCCESS,
} from 'store/actions/dataActions';
import { REFRESH_VIEW } from 'store/actions/listActions';
import { LOCATION_CHANGE } from 'connected-react-router';

const initialState = {};
let previousPathname = '';

export default ( previousState = initialState, { type, payload, meta } ) => {

    switch (type) {

        case LOCATION_CHANGE://다른 메뉴로 이동하는 경우 구조가 달라 에러발생하므로 초기화
            if( previousPathname !== '' && previousPathname !== payload.location.pathname ) {
                previousPathname = payload.location.pathname;
                return initialState;
            } else {
                previousPathname = payload.location.pathname;
                return previousState;
            }

        case CRUD_CREATE_SUCCESS:
            // 키워드 추출 
            if( meta.menu === 'DOCUMENT.FILE.TAGS' && payload && payload.keywords ) {
                return ({
                    tags : payload.keywords
                });
            }
            return previousState;
        
        case CRUD_CREATE_FAILURE:
            // 키워드 추출 
            if( meta.menu === 'DOCUMENT.FILE.TAGS' ) {
                return ({ tags : [] });
            }
            return previousState;

        case CRUD_GET_ONE_SUCCESS:
            if(meta.menu === 'DOCUMENT.GRAPH.VISUALIZATION.ADD') {
                return { graph: {...payload} };
            } else if(meta.menu === 'DOCUMENT.GRAPH.VISUALIZATION.INIT') {
                return { graph: { ...payload} };
            } else if(meta.menu === 'DOCUMENT.GRAPH.VISUALIZATION.TYPE') {
                return { graph: { ...payload} };
            }
            
            return previousState;
        
        case REFRESH_VIEW:
            return initialState;

        default:
            return previousState;
    }

}
